import * as React from 'react';

/**
 * The mark the member app's signed-out screens put above their heading.
 *
 * One module rather than an `<img>` repeated on each of them, because the thing that goes wrong
 * with a mark is not that it is hard to write — it is that four copies of it end up at three
 * heights. `/brand/logotype.png` is the 10 September bundle's `assets/logotype.png` byte for
 * byte, and `member-layout.tsx` and `phone-top-bar.tsx` already serve it from the same path.
 *
 * **Sign-in itself does not use this.** `Web App.dc.html` §3.2 puts `assets/icon.png` at 56px on
 * that one screen, above "Welcome back", with the logotype in the bar overhead — so the sign-in
 * page passes its own. These are the screens the prototype does not draw, and the wordmark is
 * what the organizer's restyled recovery established for them on 2026-09-12.
 */
export function AuthBrandMark(): React.ReactElement {
  return <img src="/brand/logotype.png" alt="H2HSpark" className="mx-auto h-5 w-auto" />;
}
